module.exports = __webpack_public_path__ + "static/media/global-nav-v1.d2f68030.gif";